/* eslint-disable arrow-body-style */
import React from 'react';
import Avatar from 'react-avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { styled, useTheme } from '@mui/system';
import Text from '../Text.js';
import { colors } from '../../theme/index.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
const StyledMenuItem = styled(MenuItem)({
  height: 'auto',
  justifyContent: 'center',
  minWidth: '100%',
  padding: '5px',
  paddingTop: '10px'
});
const TopMenuItem = styled("div")({
  padding: '30px',
  paddingTop: '20px',
  textAlign: 'center'
});
const StyledMenu = styled(Menu)({
  '& .MuiPaper-root': {
    borderRadius: 8,
    minWidth: 240
  }
});

/**
 * @param open
 * @param onClose
 * @param isAdvisorSite
 * @param isMemberSite
 * @param isMasterSite
 * @param anchorEl
 * @param toggleModal
 * @param handleCloseMenu
 * @param logout
 * @param user
 * @param name
 * @param email
 * @param testid
 * @returns {JSX.Element}
 * @constructor
 */
const MetaMenu = ({
  open,
  onClose,
  isAdvisorSite,
  isMemberSite,
  isMasterSite,
  anchorEl,
  toggleModal,
  handleCloseMenu,
  logout,
  user = {},
  name,
  email,
  testid
}) => {
  const theme = useTheme();
  const isPrivateLabel = user.isPrivateLabel;
  return /*#__PURE__*/React.createElement(StyledMenu, {
    anchorEl: anchorEl,
    open: open,
    onClose: onClose,
    disableAutoFocusItem: true,
    anchorOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      borderBottom: `${colors.surface} solid 1px`
    },
    onClick: handleCloseMenu
  }, /*#__PURE__*/React.createElement(TopMenuItem, null, /*#__PURE__*/React.createElement(Avatar, {
    name: name,
    size: "55",
    textSizeRatio: 2.2,
    round: false,
    color: theme.palette.primary.main,
    style: {
      marginBottom: 20
    }
  }), /*#__PURE__*/React.createElement(Text, {
    testid: testid,
    align: 'center',
    medium: true,
    bold: true,
    display: "block",
    customStyle: {
      lineHeight: "22.88px"
    }
  }, name), /*#__PURE__*/React.createElement(Text, {
    align: 'center',
    medium: true,
    light: true,
    display: "block"
  }, email))), isMemberSite && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledMenuItem, {
    onClick: handleCloseMenu
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    margin: "0 10px",
    display: "block",
    link: "/my-account",
    customLinkStyle: {
      textDecoration: 'none'
    }
  }, i18n.t(tokens.titles["my account"]))), !isPrivateLabel && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledMenuItem, {
    onClick: handleCloseMenu
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    margin: "0 10px",
    display: "block",
    link: "/resources",
    customLinkStyle: {
      textDecoration: 'none'
    }
  }, i18n.t(tokens.titles.resources))), /*#__PURE__*/React.createElement(StyledMenuItem, {
    onClick: handleCloseMenu
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    margin: "0 10px",
    display: "block",
    onClick: () => window.FreshworksWidget('open'),
    customLinkStyle: {
      textDecoration: 'none'
    }
  }, i18n.t(tokens.titles.help))))), isAdvisorSite && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledMenuItem, {
    onClick: () => toggleModal(isAdvisorSite ? 'showAdvisorSettingsModal' : 'showAdminSettingsModal')
  }, /*#__PURE__*/React.createElement(Text, {
    align: "center",
    medium: true,
    display: "block",
    customLinkStyle: {
      textDecoration: 'none'
    }
  }, "Settings")), /*#__PURE__*/React.createElement(StyledMenuItem, {
    onClick: () => toggleModal('showPasswordModal')
  }, /*#__PURE__*/React.createElement(Text, {
    align: "center",
    medium: true,
    display: "block",
    customLinkStyle: {
      textDecoration: 'none'
    }
  }, "Change Password"))), isMasterSite && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledMenuItem, {
    onClick: () => toggleModal('showBankingDetailsModal')
  }, /*#__PURE__*/React.createElement(Text, {
    align: "center",
    medium: true,
    display: "block",
    customLinkStyle: {
      textDecoration: 'none'
    }
  }, "Banking Details")), /*#__PURE__*/React.createElement(StyledMenuItem, {
    onClick: handleCloseMenu
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    margin: "0 10px",
    display: "block",
    link: "/billing",
    customLinkStyle: {
      textDecoration: 'none'
    }
  }, "Billing")), /*#__PURE__*/React.createElement(StyledMenuItem, {
    onClick: handleCloseMenu
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    margin: "0 10px",
    display: "block",
    link: "/administrators",
    customLinkStyle: {
      textDecoration: 'none'
    }
  }, "Administrators")), /*#__PURE__*/React.createElement(StyledMenuItem, {
    onClick: handleCloseMenu
  }, /*#__PURE__*/React.createElement(Text, {
    align: "center",
    medium: true,
    display: "block"
  }, "Resources")), /*#__PURE__*/React.createElement(StyledMenuItem, {
    onClick: handleCloseMenu
  }, /*#__PURE__*/React.createElement(Text, {
    align: "center",
    medium: true,
    display: "block"
  }, "Contact Support"))), /*#__PURE__*/React.createElement(StyledMenuItem, {
    onClick: logout
  }, /*#__PURE__*/React.createElement(Text, {
    color: colors.red,
    align: "center",
    medium: true,
    display: "block"
  }, i18n.t(tokens.titles.logout))));
};
export default MetaMenu;